import type { VFrameBase } from '@festina/life-general-types/life'
import { type Optional, stringUtils } from '@festina-life/core'
import get from 'lodash-es/get'
import { type PropsWithChildren, useEffect, useState } from 'react'

import { modifyNameToFirstEntry } from './formUtility'
import {
  type LifeStatusType,
  useLifeFormikContext,
} from './useLifeFormikContext'

type Props<T, F extends Optional<LifeStatusType['frame']>> = PropsWithChildren<
  Pick<LifeStatusType, 'frame'>
> & {
  customVFrameGetter?: ({
    name,
    frame,
    values,
  }: {
    name: string
    frame: F
    values: T
  }) => Optional<VFrameBase>
  frameHash?: number
}

// Used for updating the formik status with the current frame
export const LifeFrameUpdater = <
  T,
  F extends Optional<LifeStatusType['frame']>,
>({
  frame,
  customVFrameGetter,
  children,
  frameHash,
}: Props<T, F>) => {
  const [isFrameSet, setIsFrameSet] = useState(false)
  const { values, status, setStatus } = useLifeFormikContext<T>()

  useEffect(() => {
    setStatus({
      ...status,
      frame,
      fieldVFrame: (name: string) =>
        customVFrameGetter
          ? customVFrameGetter({ name, frame: frame as F, values })
          : get(frame, modifyNameToFirstEntry(name)),
    })
    setIsFrameSet(true)
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [frameHash, values, stringUtils.hash(JSON.stringify(frame))])

  return isFrameSet ? children : null // Some Life inputs rely on having the frame from the very start.
}
